import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import axios from "axios";
import { apiUrl } from "../../config/Config";
import { useSelector } from "react-redux";

const BudgetAllocationChart = ({ selectedaccount }) => {
  const userdata = useSelector((store) => store.userReducer.userdata);

  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState(null);

  const fetchBudgetAllocation = async () => {
    try {
      const res = await axios.get(apiUrl + "facebook_budget_allocation", {
        params: {
          ad_account_id: selectedaccount,
          range_type: "last_30_days",
        },
        headers: { Authorization: "Bearer " + userdata?.token },
      });

      const apiData = res.data?.data?.data;

      if (!apiData || !apiData.labels || apiData.labels.length === 0) {
        setChartData(null);
        setLoading(false);
        return;
      }

      setChartData({
        labels: apiData.labels,
        values: apiData.values,
        percent: apiData.percentages,
        total: apiData.total_budget,
      });

      setLoading(false);
    } catch (err) {
      console.error("Error fetching budget allocation:", err);
      setChartData(null);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!selectedaccount) return;
    fetchBudgetAllocation();
  }, [selectedaccount]);

  // -------------------------------------------------
  // CLEAN LOADING UI FIX
  // -------------------------------------------------
  if (loading)
    return (
      <div className="marketing-dashboard-ui-budget-card">
        <div className="marketing-dashboard-ui-budget-title">
          Budget Allocation
        </div>

        <div
          style={{
            height: "300px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "16px",
            color: "#777",
          }}
        >
          Loading...
        </div>
      </div>
    );

  if (!chartData)
    return (
      <div className="marketing-dashboard-ui-budget-card">
        <div className="marketing-dashboard-ui-budget-title">
          Budget Allocation
        </div>

        <div
          style={{
            height: "300px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "#777",
          }}
        >
          No Budget Data Found
        </div>
      </div>
    );

  const colors = [
    "#2E93fA",
    "#66DA26",
    "#FFA726",
    "#FF5C5C",
    "#9B59B6",
    "#16A085",
    "#eab55bff",
    "#9768ecff",
  ];

  const options = {
    labels: chartData.labels,
    colors: colors.slice(0, chartData.labels.length),
    legend: { show: false },

    chart: { type: "donut" },
    dataLabels: { enabled: false },

    plotOptions: {
      pie: {
        donut: {
          size: "72%",
          labels: {
            show: true,
            total: {
              show: true,
              label: "Total Budget",
              formatter: () =>
                `$${Number(chartData.total || 0).toLocaleString()}`,
            },
          },
        },
      },
    },
  };

  const safeSeries =
    chartData.values.reduce((a, b) => a + b, 0) === 0
      ? [1]
      : chartData.values;

  return (
    <div className="marketing-dashboard-ui-budget-card">
      <div className="marketing-dashboard-ui-budget-title">
        Budget Allocation
      </div>

      <div className="marketing-dashboard-ui-pie-chart-container">
        <div className="marketing-dashboard-ui-total-budget">
            
          <Chart options={options} series={safeSeries} type="donut" />
        </div>

        <div className="marketing-dashboard-ui-legend-list">
          {chartData.labels.map((label, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <span
                style={{
                  backgroundColor: colors[i],
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  marginRight: "8px",
                }}
              ></span>

              <span style={{ fontSize: "15px" }}>
                {label} — {chartData.percent[i]}%
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BudgetAllocationChart;
